// @flow
import type {
  PrimaryKey,
} from 'fc-flow-types/models'

export default (state: Object): PrimaryKey => state.mapModule.selectedFeatureIndices
